<template>
  <form class="form-group" @submit.prevent="handleSubmit" ref="formRef">
      <label for="name">Nom de la ville *</label>
      <input
        v-model="localData.name"
        type="text"
        id="name"
        placeholder="Ex: Yaoundé"
        required
      />
      <label for="slug">Slug *</label>
      <input
        v-model="localData.slug"
        type="text"
        id="slug"
        placeholder="Ex: yaounde"
        required
      />
      <label for="countryId">Pays *</label>
      <select v-model="localData.countryId" id="countryId" required>
        <option value="">-- Sélectionner un pays --</option>
        <option v-for="country in countries" :key="country.id" :value="country.id">
          {{ country.name }}
        </option>
      </select>
    <div v-if="error" class="error-message">{{ error }}</div>
  </form>
</template>

<script setup>
import { ref, watch } from 'vue'

const props = defineProps({
  formData: { type: Object, default: () => ({ name: '', slug: '', countryId: '' }) },
  countries: { type: Array, default: () => [] }
})

const emit = defineEmits(['submit', 'cancel'])

const formRef = ref(null)
const error = ref('')

const localData = ref({
  name: props.formData?.name || '',
  slug: props.formData?.slug || '',
  countryId: props.formData?.countryId || ''
})

watch(() => props.formData, (newFormData) => {
  if (newFormData) {
    localData.value = {
      name: newFormData.name || '',
      slug: newFormData.slug || '',
      countryId: newFormData.countryId || ''
    }
  }
}, { deep: true })

const handleSubmit = () => {
  error.value = ''

  if (!formRef.value?.checkValidity()) {
    formRef.value?.reportValidity()
    return
  }

  emit('submit', { ...localData.value })
}

defineExpose({ handleSubmit })
</script>
